import React from 'react';
import { useParams } from 'react-router-dom';
import { FormContainer } from '../../../CreateRoutes/CreateForm.styles';
import { AuthCheckAdmin } from '../../../../Utils/AuthCheck/AdminCheck.auth';
import BreadCrumbs from '../../../../Components/Breadcrumbs/BreadcrumbsComponent.component';
import HelmetHelper from '../../../../Components/PageHelmet/HelmetHelper.component';
import UserDataAdminProvider from '../../../../Utils/Users/UserDataAdminProvider';
import UserEditInnerComponent from './UserEditInner.component';

// Form for editing a user - i might not need this anymore
const EditUser = () => {
  const { id } = useParams();

  return (
    <AuthCheckAdmin>
      <HelmetHelper title="Edit User" description="Form for updating a user" />
      <FormContainer>
        <BreadCrumbs
          one="Admin Dashboard - User"
          oneLink={`/admin/user-home/${id}`}
          two="Edit User"
        />
        <h2>EDIT USER</h2>
        <UserDataAdminProvider userId={id}>
          {(user) => <UserEditInnerComponent user={user} />}
        </UserDataAdminProvider>
      </FormContainer>
    </AuthCheckAdmin>
  );
};

export default EditUser;
